import {JsonObject, JsonProperty} from "json2typescript";

@JsonObject("ProfileUpdateOutput")
export class ProfileUpdateOutput {
    @JsonProperty("name", String, true)
    public name: string = "";

    @JsonProperty("email", String, true)
    public email: string = "";

    constructor(init?: Partial<ProfileUpdateOutput>) {
        Object.assign(this, init);
    }
}
